import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isFaqActive',
  standalone: false
})
export class IsFaqActivePipe implements PipeTransform {
  public transform(faqId: number, activeStates: Map<number, boolean>, selectedId: number | null): boolean {
    if (activeStates.has(faqId)) {
      return activeStates.get(faqId)!;
    }
    if (selectedId === faqId) {
      return true;
    }
    return false;
  }
}
